import * as React from 'react';

const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <circle
      cx="12"
      cy="12.5"
      r="12"
      fill="#fff"
      className="warning-circle-svg"
    ></circle>
    <path
      fill="#FCC729"
      d="M12 17.375c.55 0 1-.45 1-1h-2a1 1 0 0 0 1 1m3-3v-2.5c0-1.535-.82-2.82-2.25-3.16v-.34a.749.749 0 1 0-1.5 0v.34c-1.435.34-2.25 1.62-2.25 3.16v2.5l-1 1v.5h8v-.5z"
      className="path-svg"
    ></path>
  </svg>
);

export default SvgIcon;
